/**************************************************
 * Nombre:       Formulario_Video
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {LinkRounded, TitleOutlined} from "@mui/icons-material";
import IngresoPdf from "../../Modulo_formularios/Componentes/IngresoPdf";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoVideo from "../../Modulo_formularios/Componentes/IngresoVideo";

const Formulario_Video = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Video en formato horizontal</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoVideo dato={'video'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre del Video'} dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Descripcion'} dato={'descripcion'} {...props}
                    />
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Video